import { createFormHook, createFormHookContexts } from "@tanstack/react-form";

import { AutocompleteField } from "./AutocompleteField";
import { NumberField } from "./NumberField";
import { NumericField } from "./NumericField";
import { OverflowField } from "./OverflowField";
import { SelectField } from "./SelectField";
import { SubmitButton } from "./SubmitButton";
import { TextField } from "./TextField";

export const { fieldContext, formContext, useFieldContext, useFormContext } = createFormHookContexts();

export const { useAppForm, withForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: { NumberField, NumericField, TextField, SelectField, AutocompleteField, OverflowField },
  formComponents: { SubmitButton },
});
